"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _breakpoint = _interopRequireDefault(require("@lmig/lmds-tokens/dist/json/core/breakpoint.json"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var defaultThresholdMap = function defaultThresholdMap() {
  return {
    base: 0,
    sm: _breakpoint["default"].lmig.breakpoint.sm.raw,
    md: _breakpoint["default"].lmig.breakpoint.md.raw,
    lg: _breakpoint["default"].lmig.breakpoint.lg.raw,
    xl: _breakpoint["default"].lmig.breakpoint.xl.raw
  };
};
var _default = exports["default"] = defaultThresholdMap();